import React from 'react'
import { Box, Grid } from '@mui/material'
import LanguageSelect from '@imports/LanguageSelect'
import SchoolBagIcon from '@assets/icons/register-drawings.svg'
import SchoolBagSmallIcon from '@assets/icons/register-drawings-small.svg'
import ParentLogin from './components/ParentLogin'

export function ParentLoginSection() {
  return (
    <Box sx={{ position: 'relative', overflow: 'hidden' }}>
      <Grid
        container
        flexDirection="column"
        sx={{ minHeight: '100vh' }}
      >
        <Grid item>
          <Box
            sx={{
              position: 'absolute',
              width: '100%',
              display: { xs: 'none', md: 'block' },
              zIndex: -1,
            }}
          >
            <SchoolBagIcon
              width="100%"
              height="100%"
            />
          </Box>
          <Box
            sx={{
              position: 'absolute',
              width: '100%',
              display: { xs: 'block', md: 'none' },
              zIndex: -1,
            }}
          >
            <SchoolBagSmallIcon
              width="100%"
              height="100%"
            />
          </Box>
          <Box>
            <ParentLogin />
          </Box>
        </Grid>
        <Grid
          item
          flexGrow={1}
          justifyContent="center"
          alignItems="flex-end"
          container
        >
          <Grid
            item
            sx={{ my: 2 }}
          >
            <LanguageSelect />
          </Grid>
        </Grid>
      </Grid>
    </Box>
  )
}

export default ParentLoginSection
